import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { CheckBoxIcon } from '../../../../icons/CheckBoxIcon'
import { GlobIcon } from '../../../../icons/GlobIcon'
import { dispatchLangSelectEvent } from '../../../../utils/language.utils'
import { useMenu } from '../../../context/MenuContext'
import { useSessionLanguage, useSessionSettings } from '../../../context/SessionSettingsContext'
import { LabeledLocales } from '../../../locale/Locale'
import { MenuSection } from '../useMenuSections'

export const useLanguageMenu = (): MenuSection => {
  const { t } = useTranslation()
  const locale = useSessionLanguage()
  const [, setSettings] = useSessionSettings()
  const { closeMenu } = useMenu()

  return useMemo(
    () => ({
      id: 'language',
      label: t('Language'),
      icon: GlobIcon,
      screenChildren: LabeledLocales.map((langItem) => ({
        id: `lang-${langItem.value}`,
        label: langItem.label,
        rightIcon: langItem.value === locale ? CheckBoxIcon : undefined,
        isSelected: langItem.value === locale,
        onClick: () => {
          setSettings({ locale: langItem.value })
          dispatchLangSelectEvent()
          closeMenu()
        },
      })),
    }),
    [t, locale, setSettings, closeMenu]
  )
}
